"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDropdown = void 0;
const react_1 = __importStar(require("react"));
const useOnOutsideClick_1 = require("../../../Hooks/useOnOutsideClick");
const Typography_1 = __importStar(require("../../UI/Typography"));
const Utils_1 = require("../../../Utils");
const style = __importStar(require("./styled"));
const useDebounce_1 = __importDefault(require("../../../Hooks/useDebounce"));
const WRAPPER_PADDINGS = 32;
const ONCHANGE_DELAY = 500;
const SelectDropdown = ({ options, optionsColor, label, labelColor, helpText, width, disabled, takeContentWidth, enableValidation, validationFunc, onChange, quantity, setQuantity, setWarning }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [calculatedWidth, setCalculatedWidth] = (0, react_1.useState)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    const listRef = (0, react_1.useRef)(null);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)();
    const [amount, setAmount] = (0, react_1.useState)(quantity || 1);
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    const debouncedAmount = (0, useDebounce_1.default)(amount, ONCHANGE_DELAY);
    const changeValue = (option) => {
        if (enableValidation && typeof validationFunc === 'function') {
            setErrorMessage(validationFunc(option === null || option === void 0 ? void 0 : option.toString()));
        }
        setIsOpen(false);
        setAmount(option);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (takeContentWidth) {
            setCalculatedWidth(((_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) + WRAPPER_PADDINGS);
        }
    }, [takeContentWidth]);
    (0, react_1.useEffect)(() => {
        if (!firstRender) {
            if (typeof onChange === 'function') {
                setWarning && setWarning('');
                debouncedAmount !== quantity && onChange(debouncedAmount);
            }
        }
        setFirstRender(false);
    }, [debouncedAmount]);
    (0, react_1.useEffect)(() => {
        if (typeof setQuantity === 'function') {
            setQuantity(amount);
        }
    }, [amount]);
    (0, react_1.useEffect)(() => {
        setAmount(quantity);
    }, [quantity]);
    (0, react_1.useEffect)(() => {
        if (enableValidation && typeof validationFunc === 'function') {
            setErrorMessage(validationFunc(amount === null || amount === void 0 ? void 0 : amount.toString()));
        }
    }, [enableValidation]);
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => setIsOpen(false));
    const onInputChange = (e) => {
        setIsOpen(false);
        const value = e.currentTarget.value;
        if (disabled || value === 'Infinity')
            return;
        if ((0, Utils_1.isNum)(value)) {
            if (+value === 0) {
                setAmount(1);
                return;
            }
            if (value[0] === '-') {
                setAmount(+value.substring(1, value.length));
                return;
            }
            if (value[value.length - 1] === '.') {
                return;
            }
            setAmount(+value);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(style.SelectTitle, { color: labelColor, type: Typography_1.Types.LABEL_ON_FORM }, label)),
        helpText && react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, helpText),
        react_1.default.createElement(style.Wrapper, { ref: wrapperRef, width: width || calculatedWidth },
            react_1.default.createElement(style.Header, { errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.error, disabled: disabled, isOpen: isOpen, onClick: () => (!disabled ? setIsOpen(!isOpen) : {}) },
                react_1.default.createElement(style.Input, { value: amount, onChange: onInputChange }),
                react_1.default.createElement(style.ArrowContainer, null,
                    react_1.default.createElement(style.ArrowIcon, { disabled: disabled, isOpen: isOpen }))),
            isOpen && !disabled && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style.List, { ref: listRef, takeContentWidth: takeContentWidth, isOpen: isOpen }, options.map((item, i) => (react_1.default.createElement(style.ListItem, { key: i, onClick: () => changeValue(item), disabled: item === amount, isSelected: item === amount },
                    react_1.default.createElement(style.ListItemName, { type: Typography_1.Types.BODY_1, isSelected: item === amount, optionsColor: optionsColor }, item))))))))));
};
exports.SelectDropdown = SelectDropdown;
exports.default = exports.SelectDropdown;
